<template lang="pug">
    section#menuEgressos
        div.wrapper
            div.mobile(@click="toggleMenuMobile()")
                p Menu
                img(:src="require('@images/icones/setaGaleria.png')", alt="Ver mais")
            ul.listaOpcoes
                li(v-for="item, index in $props.menu", v-if="item.nome", :class="{ 'ativo': $route.params.slug == item.slug }", :data-index="index").opcao
                    router-link(:to="{ path: '/' + item.slug }", :key="item.nome" v-if="!item.link_externo && (item.link_externo == '#' || item.link_externo == null)") {{ item.nome }}
                    a(:href="item.slug", target="_blank", v-else) {{ item.nome }}
                    img(:src="require('@images/icones/setaGaleria.png')", alt="Ver mais", v-if="item.children.length > 0 && item.children[0].nome != null", @click="toggleSubMenuMobile(index)").verSubmenu
                    ul(v-if="item.children.length > 0 && item.children[0].nome != null").children
                        li(v-for="child in item.children", v-if="child.nome")
                            router-link(:to="{ path: '/' + child.slug }", :key="child.nome" v-if="!child.link_externo && child.link_externo == '#'") {{ child.nome }}
                            a(:href="child.slug", target="_blank", v-else) {{ child.nome }}
        
</template>

<script>
export default {
    name: "component-menu-egressos",
    props:{
        menu: Array,
    },
    methods: {
        toggleMenuMobile() {
			document.querySelector('#menuEgressos').classList.toggle('ativo')
		},
        toggleSubMenuMobile(index) {
			document.querySelector('#menuEgressos [data-index="' + index + '"]').classList.toggle('subAtivo')
		}
    },
}
</script>

<style lang="stylus" scoped src="./MenuEgressos.styl"></style>